<div class="clear {{styles.saveListHeader}}">
    <div class="fl">已保存条件</div>
    <a class="fr" href="/buyer-ng/collect/showCollect?tab=3" target="_blank">去编辑</a>    
</div>
<ul class="{{styles.saveList}}">
    {{if props.data && props.data.length}}
      {{each props.data info index}}
        <li class="{{styles.item}}" data-index="{{index}}">
          <div class="{{styles.itemName}}"  data-index="{{index}}">
            <div class="{{styles.itemTitle}} {{props.activedSaveName === info.name && styles.actived}}" title="{{info.name}}" >{{info.name}}</div>
            <div class="{{styles.saveListTag}}" title={{each info.tags as item index}}{{item }}{{/each}}>
              {{each info.tags as item index}}
                <span class="{{props.activedSaveName === info.name && styles.actived}}">{{item}}</span>
              {{/each}}
            </div>
          </div>
          <i class="icon iconfont icon-chacha font12 {{styles.close}}" data-index="{{index}}"></i>
        </li>
      {{/each}}
    {{else}}
      <li  class="{{styles.nodata}}">您还没有保存过搜索条件呢~~</li>
    {{/if}}
</ul>



// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYFilterBar/components/OYFilterBarSaveList/index.art